import { lazy, Suspense } from "react";
import type { TripPickerProps } from "./TripPickerField";

const TripPickerField = lazy(() => import("./TripPickerField"));
export type { TripPickerProps } from "./TripPickerField";

export default function TripPicker(props: TripPickerProps) {
  return (
    <Suspense fallback={<span className="settings-note">{props.label}…</span>}>
      <TripPickerField {...props} />
    </Suspense>
  );
}
